// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"c92d6ad0","124":"3dec2280","185":"2d8bf8bc","190":"4881e374","228":"9235ede0","243":"e2ca5dea","353":"56f471c8","453":"703d9625","660":"26a53d6c","666":"4da29506","697":"35f57cc4","712":"77c983b4","720":"2a076748","819":"130d9ec1","855":"11df1a5e"}[chunkId] + ".chunk.js";
};